// app/javascript/controllers/toggle_visibility_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropdown", "toggleable"];

  connect() {
    this.toggleVisibility(); // Set initial visibility on load
  }

  toggleVisibility() {
    const selectedValue = this.dropdownTarget.value;
    this.toggleableTargets.forEach((element) => {
      const showFor = element.dataset.showFor;
      if (showFor && showFor.split(",").includes(selectedValue)) {
        element.style.display = "block";
      } else {
        element.style.display = "none";
      }
    });
  }
}
